<template>
  <div>
    <v-card class="elevation-12">
      <v-toolbar dark color="primary">
        <v-toolbar-title>Cambiar email</v-toolbar-title>
      </v-toolbar>
      <v-alert type="error" dismissible v-model="alertError">
        {{ error }}
      </v-alert>
      <v-alert type="success" dismissible v-model="alertaExito">
        Email enviado con éxito
      </v-alert>
      <form @submit.prevent="changeEmail">
        <v-card-text>
          <v-text-field
            required
            id="newEmail"
            prepend-icon="email"
            autocomplete="email"
            name="email"
            label="Nuevo email"
            v-model="email"
            type="email"
            :rules="[compareNewEmail]"
            counter
            maxlength="70"
          ></v-text-field>
          <v-text-field
            required
            id="emailConfirm"
            prepend-icon="none"
            name="email"
            autocomplete="email"
            label="Repetir email"
            v-model="emailConfirm"
            type="email"
            :rules="[compareEmails]"
            counter
            maxlength="70"
          ></v-text-field>
          <v-text-field
            required
            id="current-password"
            prepend-icon="lock"
            autocomplete="current-password"
            name="current-password"
            label="Contraseña actual"
            v-model="password"
            type="password"
            counter
            maxlength="50"
          ></v-text-field>
        </v-card-text>
        <v-card-actions>
          <v-layout wrap align-center justify-center>
            <v-flex xs12 md5>
              <v-tooltip right :disabled="loading">
                <template v-slot:activator="{ on }">
                  <v-btn
                    block
                    color="primary"
                    type="submit"
                    :disabled="validateInputs"
                    :loading="loading"
                    v-on="on"
                  >
                    Cambiar email
                  </v-btn>
                </template>
                <span>Se enviará al correo un enlace de verificación</span>
              </v-tooltip>
            </v-flex>
            <v-flex xs12 md7 />
          </v-layout>
        </v-card-actions>
      </form>
    </v-card>
    <v-dialog persistent v-model="dialog" width="500">
      <v-card>
        <v-card-title class="headline dark white--text primary" primary-title>
          <v-toolbar-title>
            <v-icon dark left>markunread_mailbox</v-icon>
            Verificar nuevo email
          </v-toolbar-title>
        </v-card-title>
        <v-alert :value="true" type="success">
          Email enviado con éxito
        </v-alert>

        <v-card-text>
          Hemos enviado un correo de verificación a <b>{{ emailDialog }}</b>
          <br />
          Haz click en el enlace para poder iniciar sesión con tu nueva dirección.
          <br />
          <br />
          También hemos enviado un aviso a tu antigua dirección de correo electrónico.
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn v-on="on" to="/signin" block dark color="blue">
                Iniciar sesión
              </v-btn>
            </template>
            <span>
              Recuerda verificar el nuevo email antes de intentar iniciar sesión
            </span>
          </v-tooltip>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
//Formulario para cambiar de email
// @group Configurar usuario
export default {
  name: "ChangeEmail",
  data() {
    return {
      procesando: false,
      alertError: false,
      alertaExito: false,
      email: "",
      emailConfirm: "",
      emailDialog: "",
      password: "",
      dialog: false
    };
  },
  methods: {
    // @vuese
    // Cambiar email
    // @arg La contraseña y el nuevo email
    changeEmail() {
      this.alertError = false;
      this.alertaExito = false;
      this.$store
        .dispatch("changeEmail", {
          email: this.email,
          password: this.password,
          uid: this.$store.state.user.uid
        })
        .then(() => {
          this.alertaExito = true;
          this.dialog = true;
          this.emailDialog = this.email;
          this.email = "";
          this.emailConfirm = "";
          this.password = "";
        })
        .catch(error => {
          this.alertError = true;
        });
    }
  },
  computed: {
    // @vuese
    // Comprueba si las condiciones se cumplen
    validateInputs() {
      if (
        this.email === "" ||
        this.emailConfirm === "" ||
        this.password === "" ||
        this.loading ||
        this.compareEmails !== true ||
        this.compareNewEmail !== true
      ) {
        return true;
      } else {
        return false;
      }
    },
    // @vuese
    // Comprueba que los dos emails sean iguales
    compareEmails() {
      return this.emailConfirm === "" || this.email === this.emailConfirm
        ? true
        : "Los emails no coinciden";
    },
    // @vuese
    // Comprueba que el nuevo email sea distinto
    compareNewEmail() {
      return this.email === "" || this.email !== this.$store.state.user.email
        ? true
        : "El nuevo email debe ser distinto";
    },
    // @vuese
    // Indica el error
    error() {
      return this.$store.state.error;
    },
    // @vuese
    // Indica si el sistema está cargando
    loading() {
      return this.$store.state.loading;
    }
  },
  watch: {
    alertError(value) {
      if (!value) {
        this.$store.commit("setError", null);
      }
    }
  }
};
</script>
